module.exports = __webpack_public_path__ + "static/media/notification-approval-icon.f8066ac6.svg";